import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49761f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            } }
const _hoisted_5 = { class: "bi-tmpl-detail__right__cmpt__radioBox" }

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

import cmpts from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-standard';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-10',
  setup(__props) {

const TYPE_MAPPING = cmpts.reduce((pre, cur) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: cName
  };
  return pre;
}, {});

const { curItem, onChange, titleCmpt, pageNoCmpt } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "xrk-card",
              onClick: ($event: any) => (_unref(onChange)(item.value)),
              style: {"width":"420px","height":"600px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_unref(titleCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleCmpt)), _mergeProps({
                      key: 0,
                      style: {"width":"1200px","transform":"scale(0.33)","transform-origin":"0 center"},
                      ref_for: true
                    }, {
                innerText: '项目执行进度',
                enInnerText: 'Project Implementation Progress',
                index: 9
              }), null, 16))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.cmpt), { style: {"width":"380px","height":"300px"} })),
                (_unref(pageNoCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                      key: 1,
                      style: {"width":"60px","height":"30px"}
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(BaseRadio), {
                value: item.value,
                "model-value": _unref(curItem).value,
                onClick: ($event: any) => (_unref(onChange)(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(), 1)
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})